const SET_QUERY_STRING = 'SET_QUERY_STRING'

export default {
	SET_QUERY_STRING
}